import React from "react";
import Link, { LinkPropType } from "@default/general-components/link/link";
import PillBorder from "@default/general-components/pill-border";
import ErrorBoundary from "@default/js/error-boundary";
import useAccessibilityContext from "@default/js/accessibility/store/use-accessibility-context";
import classNames from "classnames";

const CtaElement = ({ link }) => {
  if (!link?.uri?.path || !link?.title) return null;
  const { simpleDesign } = useAccessibilityContext();

  const buttonClassNames = classNames({
    "btn btn-primary headline-s main-cta": true,
    "simple-design-button": simpleDesign,
  });

  return (
    <div className="container cta-wrapper">
      <div className="row">
        <div className="col-12 d-flex justify-content-center">
          <ErrorBoundary>
            <Link link={link} className={buttonClassNames}>
              <PillBorder blurredBackdrop />
              <span>{link.title}</span>
            </Link>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};

CtaElement.propTypes = {
  link: LinkPropType.isRequired,
};

export default CtaElement;
